"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./CardFooter.css");

var _styles = {
  "footer": "CardFooter__footer___3It3s",
  "hide-border-top": "CardFooter__hide-border-top___3fs70",
  "no-bg-color": "CardFooter__no-bg-color___3IKbG",
  "helper-text": "CardFooter__helper-text___1wiES",
  "small": "CardFooter__small___1gcpz",
  "secondary": "CardFooter__secondary___3Q9RG",
  "secondary-action": "CardFooter__secondary-action___2WXut",
  "tertiary": "CardFooter__tertiary___3-0-6",
  "primary-action": "CardFooter__primary-action___2dP3K"
};

const styles = _bind.default.bind(_styles);

const CardFooter = (0, _mobxReact.observer)(({
  className,
  small,
  noBgColor,
  paddingTopBottom = 16,
  paddingLeftRight = 24,
  variant = 'primary',
  helperText,
  helperTextIcon,
  primaryCtaLabel,
  primaryOnClick,
  primaryCtaDisabled,
  secondaryCtaLabel,
  secondaryOnClick,
  secondaryCtaDisabled,
  primaryTestId,
  secondaryTestId,
  hideBorderTop = false,
  dataTestId,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('footer', variant, {
    'hide-border-top': hideBorderTop,
    'no-bg-color': noBgColor,
    small
  }), className);
  const helper_text_composed_classname = (0, _bind.default)(styles({
    'helper-text': !!primaryCtaLabel || !!secondaryCtaLabel
  }));
  return _react.default.createElement(_.Content, {
    flex: true,
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: variant === 'secondary' || typeof secondaryOnClick === 'object' ? 24 : 16,
    className: composed_classname,
    paddingTop: small || variant === 'tertiary' ? 8 : paddingTopBottom,
    paddingBottom: small || variant === 'tertiary' ? 8 : paddingTopBottom,
    paddingLeft: paddingLeftRight,
    paddingRight: paddingLeftRight,
    dataTestId: dataTestId,
    ...props
  }, typeof primaryOnClick === 'object' ? _react.default.createElement(_.Link, {
    variant: 'medium',
    external: primaryOnClick.external,
    href: primaryOnClick.location,
    onClick: primaryOnClick.onClick,
    className: styles('primary-action')
  }, primaryCtaLabel) : primaryCtaLabel && primaryOnClick && _react.default.createElement(_.Button, {
    label: primaryCtaLabel,
    variant: variant === 'secondary' ? 'outlined' : variant === 'tertiary' ? 'tertiary' : 'contained',
    onClick: primaryOnClick,
    className: styles('primary-action'),
    dataTestId: primaryTestId,
    disabled: primaryCtaDisabled
  }), typeof secondaryOnClick === 'object' ? _react.default.createElement(_.Link, {
    variant: 'medium',
    external: secondaryOnClick.external,
    href: secondaryOnClick.location
  }, secondaryCtaLabel) : secondaryCtaLabel && secondaryOnClick && _react.default.createElement(_.Button, {
    label: secondaryCtaLabel,
    variant: variant === 'secondary' || variant === 'tertiary' || variant === 'quaternary' ? 'tertiary' : 'outlined',
    onClick: secondaryOnClick,
    dataTestId: secondaryTestId,
    className: styles('secondary-action'),
    disabled: secondaryCtaDisabled
  }), helperText && _react.default.createElement(_.Content, {
    flex: true,
    alignItems: 'center',
    flexDirection: 'row',
    gap: 0,
    className: helper_text_composed_classname
  }, helperTextIcon && _react.default.createElement(_.Icon, {
    name: helperTextIcon,
    size: 20,
    color: _.Color.neutral._80
  }), _react.default.createElement(_.Text, {
    size: 15,
    color: _.Color.neutral._80
  }, helperText)));
});
var _default = CardFooter;
exports.default = _default;